export enum InboxStatusType {
  ALL = 'ALL',
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  CLOSE = 'CLOSE',
  ASSIGNED = 'ASSIGNED',
}
